export default __webpack_public_path__ + "static/media/kitd.1cf99012.jpg";